import { __decorate, __metadata } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
let LocalStorageServiceImpl = class LocalStorageServiceImpl {
    constructor() { }
    setItem(key, value) {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        }
        catch (e) {
            console.error(e);
        }
    }
    getItem(key) {
        try {
            return JSON.parse(localStorage.getItem(key));
        }
        catch (e) {
            console.error(e);
        }
    }
    removeItem(key) {
        try {
            localStorage.removeItem(key);
        }
        catch (e) {
            console.error(e);
        }
    }
};
LocalStorageServiceImpl = __decorate([
    injectable(),
    __metadata("design:paramtypes", [])
], LocalStorageServiceImpl);
export { LocalStorageServiceImpl };
